import ErrorWithToast from "./ErrorWithToast";

class NeedsLogin extends ErrorWithToast{
  constructor() {
    super("Essa para fazer essa ação voce precisa estar Logado");
  }
}

export default NeedsLogin;